var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01041 7.86978C8.09041 7.72578 8.24241 7.61778 8.46641 7.54578C8.69041 7.46578 8.91041 7.42578 9.12641 7.42578C9.35041 7.42578 9.54641 7.45378 9.71441 7.50978C9.40241 9.91778 9.24641 11.1338 9.24641 11.1578C9.20641 11.3178 9.18641 11.4538 9.18641 11.5658C9.18641 11.6698 9.19441 11.7618 9.21041 11.8418C9.24241 12.0498 9.38641 12.1538 9.64241 12.1538C9.90641 12.1538 10.1464 11.9858 10.3624 11.6498C10.5864 11.3058 10.7544 10.9178 10.8664 10.4858C10.9224 10.5178 11.0104 10.6138 11.1304 10.7738C11.2504 10.9338 11.3224 11.0538 11.3464 11.1338C11.1864 11.7738 10.9144 12.2898 10.5304 12.6818C10.1464 13.0738 9.68641 13.2698 9.15041 13.2698C8.61441 13.2698 8.21441 13.1378 7.95041 12.8738C7.69441 12.6098 7.56641 12.2698 7.56641 11.8538C7.56641 11.7658 7.57041 11.6738 7.57841 11.5778L8.01041 7.86978Z",
    fill: "#383434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13159 4.73047C8.86759 4.73047 8.64359 4.82647 8.45959 5.01847C8.27559 5.20247 8.18359 5.42647 8.18359 5.69047C8.18359 5.95447 8.27559 6.17847 8.45959 6.36247C8.64359 6.54647 8.86759 6.63847 9.13159 6.63847C9.39559 6.63847 9.61959 6.54647 9.80359 6.36247C9.99559 6.17847 10.0916 5.95447 10.0916 5.69047C10.0916 5.42647 9.99559 5.20247 9.80359 5.01847C9.61959 4.82647 9.39559 4.73047 9.13159 4.73047Z",
    fill: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestion);
export default __webpack_public_path__ + "static/media/suggestion.f506a34d8e245561e455b2735a649fe8.svg";
export { ForwardRef as ReactComponent };